
import { Component, Vue } from 'vue-property-decorator'
import WhitelabelList from '@/components/whitelabel/WhitelabelList.vue'
import authModule from '@/store/auth'

@Component({
  name: 'Whitelabels',
  components: { WhitelabelList }
})
class Whitelabels extends Vue {
  private created(): void {
    if (!authModule.isSuperadmin) {
      this.$router.replace({ name: 'Home' })
    }
  }
}

export default Whitelabels
